/**
 * 标签路径展示：只取每段路径的最后一级（节/叶子名）
 */
export function getLeafTagNames(tagStr) {
  if (!tagStr) return []
  return String(tagStr)
    .split(/[,，]/)
    .map(extractLeafTagName)
    .filter(Boolean)
}

function extractLeafTagName(tagPath) {
  const normalized = String(tagPath || '').trim()
  if (!normalized) return ''
  const parts = normalized.split(/\s*[\/／|>]\s*/).map(p => p.trim()).filter(Boolean)
  if (!parts.length) return normalized
  return parts[parts.length - 1]
}
